module.exports = __webpack_public_path__ + "static/media/Artboard3.da059fe2.png";